import styled from 'styled-components'
import {shade} from 'polished'


export const VideoChamadaSucessoModal = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const RedArea = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #F3123C;
    border-radius: 8px;
    flex: 1;
    background-color: #F3123C;
    color: #fff;
    padding: 48px;

    @media screen and (max-width:1366px) {
        padding: 20px 35px;
    }
`

export const MainText = styled.h1`
    font-size: 32px;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 10px;
`

export const Info = styled.h2`
    font-size: ${props => !props.small ? '24px' : '20px'};
    font-weight: 500;
    line-height: 150%;
    margin-bottom: ${props => !props.small ? '40px' : '20px'};
`

export const MainInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #fff;
    color: #2E2D37;
    padding: 48px;

    @media screen and (max-width:1366px) {
        padding: 20px 35px;
    }
`

export const InfoText = styled.h3`
    font-size: 18px;
    font-weight: 500;
    line-height: 150%;
`

export const FlexContainer = styled.div`
    display: flex;
    margin-top: 25px;
`

export const LeftColumn = styled.div`
    margin-right: 100px;
`

export const RightColumn = styled.div``

export const GrayInfo = styled.h4`
    font-size: 14px;
    color: #696977;
    line-height: 150%;
    font-weight: 500;
    margin-bottom: 20px;
`

export const SellerInfo = styled.h3`
    display: flex;

    h3 {
        margin-top: 5px;
    }
`

export const SellerBadge = styled.div`
    display: ${props => !!props.badge ? 'block' : 'none'};
    background-image: url(${props => props.badge});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 78px;
    height: 32px;
    margin-right: 10px;
`

export const BoldInfo = styled.h3`
    font-size: 18px;
    font-weight: 500;
`

export const DayOfWeek = styled.h4`
    font-size: 12px;
`

export const ButtonContainer = styled.div`
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
`

export const Quit = styled.button`
    border: 1px solid #F3123C;
    border-radius: 8px;
    padding: 11px 20px;
    background-color: #fff;
    font-weight: bold;
    font-size: 12px;
    line-height: 150%;
    color: #F3123C;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
        transition: all 0.2s;
        color: ${shade(0.2, '#F3123C')};
        border-color: ${shade(0.2, '#F3123C')};
    }
`
